{
  "colorSwatchPicker": "Próbki kolorów",
  "dropzoneLabel": "Strefa upuszczania",
  "selectPlaceholder": "Wybierz element",
  "tableResizer": "Zmiana rozmiaru"
}
